/**
 * @Author: abbeymart | Abi Akindele
 * @Date: 2018-09-24 | 12:48 PM
 * @LastEditors: abbeymart
 * @Updates: 2018-09-24 | 12:48 PM - actions taken
 * @Description: mc: bookmark routes
 * @Company: mConnect.biz
 * @License: MIT
 */

import type { RouteRecordRaw } from 'vue-router';

export const bookmarkRoutes: Array<RouteRecordRaw> = [
  {
    path: '/bookmark',
    name: 'bookmark',
    redirect: '/bookmark/list',
    component: () => import('pages/central/bookmark/McBookmark.vue'),
    meta: {
      title: 'Bookmarks - Favourites',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'bookmarkList',
        component: () => import('pages/central/bookmark/BookmarkList.vue'),
        meta: {
          title: 'Bookmarks / Favourites List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'bookmarkDetail',
        component: () => import('pages/central/bookmark/BookmarkDetail.vue'),
        meta: {
          title: 'Bookmark Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'bookmarkNew',
        component: () => import('pages/central/bookmark/BookmarkNew.vue'),
        meta: {
          title: 'New Bookmark',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'bookmarkExplorer',
        component: () => import('pages/central/bookmark/BookmarkExplorerDtable.vue' ),
        meta: {
          title: 'Bookmarks Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
